export default "__VITE_ASSET__BODkLY5H__"